<mat-dialog-content class="dialog-content">
  <div style="width: 100%">
    <div class="flex gap-12px" style="position: relative; padding-bottom: 20px">
      <div
        style="width: 50px; height: 50px; margin-top: -12px"
        *ngIf="data.showIcon">
        <mat-icon
          svgIcon="bringliesel-icon"
          class="bringliesel-icon"></mat-icon>
      </div>
      <div class="text" [innerHTML]="data.message"></div>
    </div>

    <div class="buttons-container">
      <button
        *ngFor="let button of data.buttons"
        class="button"
        style="--color: {{ button.color }}"
        (click)="
          button.closeDialog ? closeDialog(false) : performAction(button.id)
        ">
        {{ button.text }}
      </button>
    </div>
  </div>
  <div style="position: relative">
    <app-modal-close-button
      class="close-button"
      *ngIf="data.closable"
      [closeDialog]="closeDialog.bind(this)"></app-modal-close-button>
  </div>
</mat-dialog-content>
